import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "absolute right-0 top-0 bottom-0 w-full max-w-sm bg-white shadow-2xl flex flex-col" }
const _hoisted_4 = { class: "flex items-center justify-between px-4 py-3 sm:px-5 sm:py-4 border-b border-cream-200" }
const _hoisted_5 = { class: "font-display font-bold text-accent text-base sm:text-lg" }
const _hoisted_6 = {
  key: 0,
  class: "text-brand ml-1 text-base"
}
const _hoisted_7 = { class: "flex-1 overflow-y-auto px-4 py-3 sm:px-5 sm:py-4" }
const _hoisted_8 = {
  key: 0,
  class: "text-center py-16 text-accent/40"
}
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col gap-4"
}
const _hoisted_10 = { class: "w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-cream-200 flex items-center justify-center text-xl sm:text-2xl flex-shrink-0" }
const _hoisted_11 = { class: "flex-1 min-w-0" }
const _hoisted_12 = { class: "font-semibold text-accent text-sm truncate" }
const _hoisted_13 = { class: "text-xs text-accent/50" }
const _hoisted_14 = { class: "flex items-center gap-1.5" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "w-5 text-center text-sm font-semibold text-accent" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "px-4 py-3 sm:px-5 sm:py-4 border-t border-cream-200 space-y-3"
}
const _hoisted_19 = { class: "flex justify-between font-display font-bold text-accent text-lg" }
const _hoisted_20 = { class: "text-brand" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppNavbar = _resolveComponent("AppNavbar")!
  const _component_HeroBanner = _resolveComponent("HeroBanner")!
  const _component_TodayMenuSection = _resolveComponent("TodayMenuSection")!
  const _component_HowItWorks = _resolveComponent("HowItWorks")!
  const _component_TestimonialsSection = _resolveComponent("TestimonialsSection")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppNavbar, {
      "cart-count": _ctx.cartCount,
      onOpenCart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cartOpen = true))
    }, null, 8, ["cart-count"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_HeroBanner),
      _createVNode(_component_TodayMenuSection, { onAddToCart: _ctx.addToCart }, null, 8, ["onAddToCart"]),
      _createVNode(_component_HowItWorks),
      _createVNode(_component_TestimonialsSection)
    ]),
    _createVNode(_component_AppFooter),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition duration-150 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.cartOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-accent/40 z-50 backdrop-blur-sm",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.cartOpen = false), ["self"]))
            }, [
              _createElementVNode("aside", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Your Order ", -1)),
                    (_ctx.cartCount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, "(" + _toDisplayString(_ctx.cartCount) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    class: "p-2 rounded-xl hover:bg-cream-200 transition-colors",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cartOpen = false))
                  }, [
                    _createVNode(_component_XMarkIcon, { class: "w-5 h-5 text-accent" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.cartItems.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("p", { class: "text-4xl mb-3" }, "🛒", -1),
                        _createElementVNode("p", { class: "font-semibold" }, "Your cart is empty", -1),
                        _createElementVNode("p", { class: "text-sm mt-1" }, "Add dishes from today's menu", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (entry, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: entry.item.id,
                            class: "flex items-center gap-3"
                          }, [
                            _createElementVNode("div", _hoisted_10, _toDisplayString(entry.item.emoji || '🍽️'), 1),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, _toDisplayString(entry.item.name), 1),
                              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.formatPrice(entry.item.price)) + " Rwf × " + _toDisplayString(entry.qty), 1)
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("button", {
                                class: "w-6 h-6 sm:w-7 sm:h-7 rounded-lg bg-cream-200 text-accent hover:bg-brand hover:text-white transition-colors text-xs sm:text-sm font-bold",
                                onClick: ($event: any) => (_ctx.dec(index))
                              }, "−", 8, _hoisted_15),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(entry.qty), 1),
                              _createElementVNode("button", {
                                class: "w-6 h-6 sm:w-7 sm:h-7 rounded-lg bg-cream-200 text-accent hover:bg-brand hover:text-white transition-colors text-xs sm:text-sm font-bold",
                                onClick: ($event: any) => (_ctx.inc(entry.item))
                              }, "+", 8, _hoisted_17)
                            ])
                          ]))
                        }), 128))
                      ]))
                ]),
                (_ctx.cartItems.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "Total", -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatPrice(_ctx.cartTotal)) + " Rwf", 1)
                      ]),
                      _createVNode(_component_router_link, {
                        to: "/checkout",
                        class: "btn-primary w-full text-base py-3 text-center",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cartOpen = false))
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode(" Proceed to Checkout ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("button", {
                        class: "w-full text-xs text-accent/40 hover:text-accent transition-colors py-1",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearCart && _ctx.clearCart(...args)))
                      }, " Clear cart ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}